import script from "./EntityValuePicker.vue?vue&type=script&setup=true&lang=js"
export * from "./EntityValuePicker.vue?vue&type=script&setup=true&lang=js"

import "./EntityValuePicker.vue?vue&type=style&index=0&id=60608ad3&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60608ad3"]])

export default __exports__